<template>
  <div class="header-section">
    <div class="row">
    <h2 class="col-md-12 col-xs-12 col-sm-12">Invoice #{{ data.InvoiceNumber }}</h2>
    </div>
    <div class="row">
      <h3 class="muted col-md-12 col-xs-12 col-sm-12">
      <template v-if="data.InvoiceDate">
        Invoiced {{ formatDate(data.InvoiceDate) }}
      </template>
      <template v-else>
        No Invoice Date
      </template>
    </h3>
    </div>
    <form v-show="!showShippingDetails" :action="data.exportAction" method="POST" target="_blank">
      <div class="col-md-12 col-xs-12 col-sm-12 mb-2">
      <input type="hidden" name="accountId" :value="data.accountId">
      <input type="hidden" name="userId" :value="data.userId">
      <input
        type="hidden"
        name="invoices"
        :value="invoicePrintValue"
      >
      </div>      
      <div class="row mb-2">
          <div class="col-md-2 col-xs-12 col-sm-12">
          <b-button
            v-if="canPrintInvoices"
            type="submit"
            class="btn-print mb-1"
            name="format" 
            :value="'PDF'" 
            size="sm"        
          >
            {{ getContentItem("exportAsPDF") }}
          </b-button>
        </div>
        <div class="col-md-2 col-xs-12 col-sm-12">
          <b-button
            v-if="canPrintInvoices"
            type="submit"
            class="btn-print mb-1"
            name="format" 
            :value="'Excel'" 
            size="sm"
          >
            {{ getContentItem("ExportToExcel") }}
          </b-button>
          </div>
          <div class="col-md-2 col-xs-12 col-sm-12">
          <b-button
            v-if="canPrintInvoices"
            type="submit"
            class="btn-print mb-1"
            name="format" 
            :value="'Word'" 
            size="sm"
          >
            {{ getContentItem("ExportToWord") }}
          </b-button>
          </div>
    </div>
  </form>
    <b-row>
      <b-col xs="12" sm="6">
        <div class="detail-section row">
          <h2 class="col">
            {{ getContentItem("billTo") }}
          </h2>
          <div v-if="billToDealerCode" class="col dealer-code">
            {{ billToDealerCode }}
          </div>
        </div>
        <p class="detail-address">
          <PostalAddress :address="getAddress(data.BillTo)" />
        </p>
      </b-col>
      <b-col xs="12" sm="6">
        <div class="detail-section row">
          <h2 class="col">
            {{ getContentItem("shipTo") }}
          </h2>
          <div v-if="shipToDealerCode" class="col dealer-code">
            {{ shipToDealerCode }}
          </div>
        </div>
        <p class="detail-address">
          <PostalAddress :address="getAddress(data.ShipTo)" />
        </p>
      </b-col>
    </b-row>
    <b-row v-if="data.NotifyParty">
      <b-col xs="12">
        <div class="detail-section">
          <h2>{{ getContentItem("finalTo") }}</h2>
        </div>
        <p class="detail-address">
          <PostalAddress :address="getAddress(data.NotifyParty)" />
        </p>
      </b-col>
    </b-row>
    <div class="detail-section">
      <h2>{{ getContentItem("otherInfo") }}</h2>
    </div>
    <div class="header-details">
      <b-row>
        <b-col xs="12" sm="6">
          <static-form-control
          id="ship-via"
            :label-text="getContentItem('shippedVia')"
            :value="data.ShipVia"
            :cols="3"
          />          
          <div class="btn btn-default m-2">
            <shipping-detail            
              :invoice-id="data.Id"
              :invoice-source="data.InvoiceSource"
              :invoice-number="data.InvoiceNumber"
              @loadDetail="ShowShippingDetail"
            />
          </div>
        </b-col>
        <b-col v-if="getCommercialInvoice().length > 0" xs="12" sm="6">
          <static-form-control
            id="commercial-invoice"
            label-text="Commercial Invoice"
            :value="getCommercialInvoice()"
            :cols="3"
          />          
        </b-col>
        <b-col v-if="data.RevisionNumber && data.isNotRapidPartsInvoice" xs="12" sm="6">
          <static-form-control
            id="revision-number"
            :label-text="getContentItem('revisionNumber')"
            :value="data.RevisionNumber"
            :cols="3"
          />
        </b-col>
        <b-col v-if="data.isRapidPartsInvoice" xs="12" sm="6">
          <static-form-control
            id="po-number"
            :label-text="getContentItem('poNumber')"
            :value="getPONumbersHtml()"
            :cols="3"
          />
        </b-col>
      </b-row>
      <b-row v-if="data.isRapidPartsInvoice">
        <b-col xs="12" sm="6" />
        <b-col xs="12" sm="6">
          <static-form-control
            v-if="data.DealerClaimAmount > 0"
            id="one-bill-invoice-number"
            :label-text="getContentItem('OneBillInvoiceNumber')"
            :value="data.ReferenceNumber"
            :cols="3"
          />
        </b-col>
      </b-row>
    </div>
    <div 
      v-if="data.HeaderNotes.length > 0"
      class="detail-section"
    >
      <h2>{{ getContentItem("comments") }}</h2>
    </div>
    <div class="header-details">
      <b-row 
        v-for="note in data.HeaderNotes" 
        :key="note.NoteId"
      >
        <b-col xs="12" sm="6">
          <static-form-control
            id="note-type"
            :label-text="getContentItem('Type')"
            :value="note.NoteCategoryDescription"
            :cols="3"
          />
        </b-col>
        <b-col xs="12" sm="6">
          <static-form-control
            id="note"
            :label-text="getContentItem('Comment')"
            :value="note.OrderNote"
            :cols="3"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import { mapGetters } from "vuex";
  import { PostalAddress, StaticFormControl } from "@/components/Elements";
  import { ShippingDetail } from "@/components/Logistics";
  import { FeatureFlagService } from "@/services/FeatureFlagService"

  export default {
    name: "InvoiceDetailsHeader",
    components: {
      PostalAddress,
      StaticFormControl,
      ShippingDetail
    },
    props: {
      data: Object,
    },
    data: () => ({
      showShippingDetails: false,
    }),  
    computed: {
      ...mapGetters(["getContentItem", "IsMcfe", "hasPermission"]),

      isMcfSap() {
        return this.data.isNotRapidPartsInvoice && !this.data.RevisionNumber;
      },
      isMcfNet() {
        return this.data.isNotRapidPartsInvoice && this.data.RevisionNumber;
      },
      billToDealerCode() {
        if (this.data.isRapidPartsInvoice) {
          return null;
        }

        return this.isMcfSap ? this.data.CustomerNumber : null;
      },
      shipToDealerCode() {
        if (this.data.isRapidPartsInvoice) {
          return this.data.CustomerNumber;
        }

        return this.isMcfNet ? this.data.CustomerNumber : null;
      },
      invoicePrintValue() {
        return `${this.data.Id}:${this.data.InvoiceSource}`
      },
      canPrintInvoices() {
        return !this.hasPermission("HideInvoicePricing");
      }
    },
    created(){
    }, 
    methods: {
      formatDate: function(value) {
        return moment(value).format("MMM D, YYYY");
      },

      getAddress: function(address) {
        if (!address) {
          return null;
        }

        return {
          ...address,
          Name: address.Name1,
          AddressLine1: address.Street1,
          AddressLine2: address.Street2,
          AddressLine3: address.Street3
        };
      },
      getCommercialInvoice: function() {
        if (!this.data.LineItems) {
          return "";
        }
        return [
          ...new Set(this.data.LineItems.map(x => x.CommercialInvoiceNumber))
        ].join("<br />");

      },
      getPONumbersHtml: function() {
        if (!this.data.LineItems) {
          return "";
        }

        return [
          ...new Set(this.data.LineItems.map(x => x.PurchaseOrderNumber))
        ].join("<br />");
      },
      ShowShippingDetail(details, invoiceNumber, invoiceId) {
        this.$emit("showLanterDetails", details, invoiceNumber, invoiceId)
      },
      ReturnFromDetails(){
        this.showShippingDetails = false;
        this.$emit("return");
      },
    }
  };
</script>
